/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ReleaseInputs */

const en_release = /** @type {(inputs: ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release`)
};

const es_release = /** @type {(inputs: ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liberar`)
};

/**
* | output |
* | --- |
* | "Release" |
*
* @param {ReleaseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const release = /** @type {((inputs?: ReleaseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ReleaseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_release(inputs)
	return es_release(inputs)
});